import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { User } from "./sharedTypes"

export type UserPermission =
  | "view_platform_overview"
  | "create_merchant"
  | "access_admin"
  | "bulk_unpair_terminals"
  | "view_terminals"
  | "view_users"
  | "manage_users"

const retrieveSelfUser = async () => {
  try {
    const { body } = await api.get<User>("/users/me/")
    return body
  } catch (error) {
    if (
      error instanceof ApiError &&
      (error.status === 403 || error.status === 404)
    ) {
      return null
    } else {
      throw error
    }
  }
}

export const CURRENT_USER_QUERY_KEY = "current_user"
export const useCurrentUser = () => {
  const { data, ...queryReturn } = useQuery({
    queryKey: [CURRENT_USER_QUERY_KEY],
    queryFn: () => retrieveSelfUser(),
    retry: false,
  })

  return {
    currentUser: data,
    ...queryReturn,
  }
}
